<template>
    <div>
        <div ref="staticRoot" class="qd-login-v3-mobile-root"></div>
        <wise-footer/>
    </div>
</template>

<script>
import WiseFooter from './components/WiseFooter.vue';

const STATIC_BASE = '/static/loginV3Mobile-static';
const STATIC_STYLES = ['base-styles.min.css', 'styles.min.css', 'mobile/mobile.min.css'];
const STATIC_SCRIPTS = ['base-script.min.js', 'mobile/mobile.min.js'];

function loadStyle(href) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.loginV3MobileStatic = 'true';
    document.head.appendChild(link);
    return link;
}

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.dataset.loginV3MobileStatic = 'true';
        script.onload = () => resolve(script);
        script.onerror = reject;
        document.body.appendChild(script);
    });
}

export default {
    name: 'LoginV3Mobile',
    components: {
        'wise-footer': WiseFooter
    },
    inject: ['$toast'],
    data() {
        return {
            styleEls: [],
            scriptEls: [],
            bodyAttrNames: []
        };
    },
    async mounted() {
        this.loadStaticStyles();
        const injected = await this.injectStaticMarkup();
        if (!injected) {
            return;
        }
        this.loadStaticScripts();
    },
    beforeDestroy() {
        this.styleEls.forEach(el => el.remove());
        this.scriptEls.forEach(el => el.remove());
        this.bodyAttrNames.forEach(name => document.body.removeAttribute(name));
    },
    methods: {
        loadStaticStyles() {
            this.styleEls = STATIC_STYLES.map(name => loadStyle(`${STATIC_BASE}/${name}`));
        },
        async injectStaticMarkup() {
            try {
                const res = await fetch(`${STATIC_BASE}/index.html`);
                const html = await res.text();
                const bodyMatch = html.match(/<body([^>]*)>([\s\S]*)<\/body>/i);
                const bodyAttrs = bodyMatch ? bodyMatch[1] : '';
                const bodyContent = bodyMatch ? bodyMatch[2] : html;
                this.applyBodyAttrs(bodyAttrs);
                this.$refs.staticRoot.innerHTML = bodyContent;
                return true;
            }
            catch (e) {
                this.$toast?.warn?.('页面加载失败，请刷新重试');
                return false;
            }
        },
        applyBodyAttrs(attrString) {
            const attrPattern = /([\w-]+)="([^"]*)"/g;
            let match = attrPattern.exec(attrString);
            while (match) {
                document.body.setAttribute(match[1], match[2]);
                this.bodyAttrNames.push(match[1]);
                match = attrPattern.exec(attrString);
            }
        },
        async loadStaticScripts() {
            for (const name of STATIC_SCRIPTS) {
                const el = await loadScript(`${STATIC_BASE}/${name}`); // eslint-disable-line no-await-in-loop
                this.scriptEls.push(el);
            }
        }
    }
};
</script>
